import Link from "next/link";
import { useRouter } from "next/router";
import { useState } from "react";
import { MdStarBorder as MenuStarIcon } from "react-icons/md";
import DestinationPicker, {
  DestinationPickerLocation,
} from "./DestinationPicker";
import styles from "./Header.module.scss";

type CountryPickerProps = {
  locations: DestinationPickerLocation[];
  loading?: boolean;
};
export function CountryPicker({ locations, loading }: CountryPickerProps) {
  const router = useRouter();
  const [visibleSubMenu, setVisibleSubMenu] = useState<string | null>(null);

  const handleMouseEnter = (country: string) => setVisibleSubMenu(country);
  const handleMouseLeave = () => setVisibleSubMenu(null);

  return (
    <nav
      title="Search by city navigation"
      className={styles.AppHeaderCityPicker}
    >
      <ul>
        <li
          className={styles.SubMenuParent}
          onMouseEnter={() => handleMouseEnter("japan")}
          onMouseLeave={handleMouseLeave}
        >
          <Link
            href={`/tours-japan?ref=nav`}
            className={styles.AppHeaderButton}
            onClick={handleMouseLeave}
          >
            <MenuStarIcon size={18} />
            <span> Japan</span>
          </Link>
          <div
            style={
              visibleSubMenu === "japan"
                ? { display: "block" }
                : { display: "none" }
            }
          >
            <div className={styles.SubMenuArrow}></div>
            <DestinationPicker
              locations={locations}
              loading={loading}
              countryId={"a032f3f0-81a8-41ac-bf04-f46e3be952a5"}
              onCityPick={(slug) => {
                router.push(`/tours-japan/${slug}`);
              }}
            />
          </div>
        </li>

        <li
          className={styles.SubMenuParent}
          onMouseEnter={() => handleMouseEnter("thailand")}
          onMouseLeave={handleMouseLeave}
        >
          <Link
            href={`/tours-thailand?ref=nav`}
            className={styles.AppHeaderButton}
            onClick={handleMouseLeave}
          >
            <MenuStarIcon size={18} />
            <span> Thailand</span>
          </Link>
          <div
            style={
              visibleSubMenu === "thailand"
                ? { display: "block" }
                : { display: "none" }
            }
          >
            <div className={styles.SubMenuArrow}></div>
            <DestinationPicker
              locations={locations}
              loading={loading}
              countryId={"d6ab9244-a663-43b3-b5ac-92064879d22b"}
              onCityPick={(slug) => {
                router.push(`/tours-thailand/${slug}`);
              }}
            />
          </div>
        </li>
      </ul>
    </nav>
  );
}
